export class CoachEducation {
    constructor(title, school, year) {
        this.title = title;
        this.school = school;
        this.year = year;
    }
}
